import React from 'react';
import { Navigate } from 'react-router';
import { Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { authenticatorSettings } from './login/authenticatorSettings';
import { useGet } from '../hooks/useApi';
import { systemApi } from '../APIs/systemApi';
import { cognitoConstants } from '../consts';

export const Login = () => {
    const { route, user } = useAuthenticator((context) => [context.route]);
    const { data: systemInfo } = useGet(systemApi.get.info);

    if (route === 'authenticated' && user) {
        return <Navigate to="/app/home" replace />;
    }

    const beCognito = systemInfo?.cognito?.userPoolId;
    const feCognito = cognitoConstants.Auth.Cognito.userPoolId;
    if (systemInfo && beCognito && beCognito !== feCognito) {
        return (
            <div data-amplify-authenticator data-variation="default">
                <div data-amplify-container>
                    <div style={{ padding: 'var(--amplify-space-xxl' }}></div>
                    <div data-amplify-router>
                        <div data-amplify-router-content>
                            <div
                                style={{
                                    margin: 'var(--amplify-space-xl)',
                                }}
                            >
                                <h6
                                    className="amplify-heading amplify-heading--6"
                                    style={{
                                        fontSize:
                                            'var(--amplify-font-sizes-large)',
                                    }}
                                >
                                    Error: User Cognito Mismatch
                                </h6>
                                <ul>
                                    <li>Frontend: {feCognito}</li>
                                    <li>Backend: {beCognito}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return <Authenticator {...authenticatorSettings} />;
};
